import React from 'react';

export const Buttons = () => {
  return (
    <div className='example-container'>
      <div className='buttons-container primary'>
        <button className='button primary sm'>Sm Button</button>
        <button className='button primary'>Primary Button</button>
        <button className='button primary lg'>Large Button</button>
        <button className='button primary sm' disabled>Disabled</button>
      </div>
      <div className='buttons-container secondary'>
        <button className='button secondary sm'>Sm Button</button>
        <button className='button secondary'>Secondary Button</button>
        <button className='button secondary lg'>Large Button</button>
        <button className='button secondary sm' disabled>Disabled</button>
      </div>
      <div className='buttons-container tertiary'>
        <button className='button tertiary sm'>Sm Button</button>
        <button className='button tertiary'>Tertiary Button</button>
        <button className='button tertiary lg'>Large Button</button>
        <button className='button tertiary sm' disabled>Disabled</button>
      </div>
      <div className='buttons-container warning'>
        <button className='button warning sm'>Sm Button</button>
        <button className='button warning'>Warning Button</button>
        <button className='button warning lg'>Large Button</button>
        <button className='button warning sm' disabled>Disabled</button>
      </div>
      <div className='buttons-container warning-hollow'>
        <button className='button warning-hollow sm'>Sm Button</button>
        <button className='button warning-hollow'>Warning Button</button>
        <button className='button warning-hollow lg'>Large Button</button>
        <button className='button warning-hollow sm' disabled>Disabled</button>
      </div>
    </div>
  )
}
